import React from 'react'
import PublicTournaments from "../tournaments/PublicTournaments";
import PublicTournamentsNeu from "./PublicTournamentsNeu";
import AnsichtWechselKnopf from "../tournamentneu/AnsichtWechselKnopf";
import {useOeffentlicheAnsicht} from "../../../../util/oeffentlicheAnsichtZugriff";

/**
 * Entscheidet, ob die alte oder die neue Eventübersicht angezeigt wird.
 * Der Wechsel über den Knopf oben rechts gilt dauerhaft und für alle öffentlichen Seiten.
 */
export default function PublicTournamentsAnsicht(props) {

    const ansicht = useOeffentlicheAnsicht();

    return <AnsichtWechselKnopf neueAnsicht={ansicht.neueAnsicht} onWechseln={ansicht.wechseln}>
        {ansicht.neueAnsicht ? <PublicTournamentsNeu {...props}/> : <PublicTournaments {...props}/>}
    </AnsichtWechselKnopf>
}
